import Events from "@wwdev/bootstrap/Events";
import Animate from "../../base/Animate";

class Tags {
	constructor(config) {
		this.config = Object.assign({
			scope: '',
			tags: '',
			items: '',
			paginator: '',
			searchForm: '',
			searchInput: 'input[name="q"]',
			tag: '',
			ajaxUrl: window.location.href.split('?')[0],
			eventNameSpace: 'taggables',
            multiple: false
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}

		this.stickyOffsetHeight = 175;
	}

	init() {
		this.initRequest();
		this.initEventListeners();
	}

	initRequest() {
		this.request = {};
		let $input = this.$scope.find(`${this.config.searchForm} ${this.config.searchInput}`);

		if ($input.val()) {
			this.request['q'] = $input.val();
		}

		this.request['tags'] = [];
		this.$scope.find(this.config.tag + '[data-active="true"]').each((index, element) => {
			this.request['tags'].push($(element).data('tag'));
		});
	}

	initEventListeners() {
		$(document).off(`.${this.config.eventNameSpace}`)
			.on(`click.${this.config.eventNameSpace}`, this.config.tag, this.toggleTag.bind(this))
			.on(`click.${this.config.eventNameSpace}`, this.config.paginator + ' .page-link', this.changePage.bind(this))
			.on(`submit.${this.config.eventNameSpace}`, this.config.searchForm, this.search.bind(this));
	}

	toggleTag(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let tag = $button.data('tag');

		if (tag === 'all') {
			this.request['tags'] = [];
			this.reload();
			return;
		}

        if (this.config.multiple) {
            if (this.request['tags'].includes(tag)) {
                this.request['tags'] = this.request['tags'].filter((id) => id !== tag);
            } else {
                this.request['tags'].push(tag);
            }
        } else {
            this.request['tags'] = [tag];
        }

		this.request['page'] = 1;

		this.reload();
	}

	changePage(event) {
		event.preventDefault();
		this.request['page'] = $(event.currentTarget).data('page');
		this.scroll = true;
		this.reload();
	}

	search(event) {
		event.preventDefault();
		let $element = $(event.currentTarget);
		let $scope = $element.closest(this.config.scope);
		let $input = $scope.find(`${this.config.searchForm} ${this.config.searchInput}`);
		let search = $input.val();
		if(search) {
			this.request['q'] = search;
		} else {
			delete this.request['q'];
		}
		this.request['page'] = 1;
		this.reload();
	}

	async reload() {
		this.beforeCallback();
		let request = {...this.request};
		request['action'] = 'reload';

		await $.ajax({
			url: this.config.ajaxUrl,
			method: 'GET',
			data: request,
			success: this.onSuccess.bind(this),
			error: this.onError.bind(this),
		});

		this.afterCallback();
	}

	onSuccess(response) {
		this.$scope.find(this.config.tags).html(response.tags);
		this.$scope.find(this.config.items).html(response.items);
		this.$scope.find(this.config.paginator).html(response.paginator);

		let url = window.location.href.split('?')[0];
		let query = $.param(this.request);
		window.history.pushState(this.request, '', `${url}?${query}`);
	}

	onError(error) {
		alert('Er is helaas iets fout gegaan.')
	}

	beforeCallback() {

	}

	afterCallback() {
		if(this.scroll) {
			this.resetScroll();
		}
		this.scroll = false;
		Events.trigger('wwdev.reset-filter-observer');
        new Animate();
	}

	resetScroll() {
		$([document.documentElement, document.body]).animate({
			scrollTop: this.$scope.offset().top - this.stickyOffsetHeight
		}, 250);
	}
}

export default Tags;
